module.exports = __webpack_public_path__ + "img/tajikistan.249e5f95.svg";